var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.49902 6.89425C4.49902 6.89425 4.95736 6.89425 5.41569 7.81091C5.41569 7.81091 6.87159 5.51925 8.16569 5.06091",
    stroke: "#2E77D0",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 6.0616V4.73105C9.99902 3.97938 9.99902 3.60355 9.81381 3.35834C9.6286 3.11313 9.20982 2.99409 8.37226 2.75601C7.80003 2.59334 7.29559 2.39737 6.89258 2.21847C6.34308 1.97455 6.06836 1.85258 5.87402 1.85258C5.67969 1.85258 5.40497 1.97455 4.85547 2.21847C4.45245 2.39737 3.94803 2.59334 3.3758 2.75601C2.53824 2.99409 2.11946 3.11313 1.93424 3.35834C1.74902 3.60355 1.74902 3.97938 1.74902 4.73105V6.0616C1.74902 8.63981 4.06946 10.1867 5.22961 10.799C5.50786 10.9458 5.64697 11.0193 5.87402 11.0193C6.10108 11.0193 6.24019 10.9458 6.51844 10.799C7.67857 10.1867 9.99902 8.63981 9.99902 6.0616Z",
    stroke: "#2E77D0",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.374023 0.935913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceType);
export default __webpack_public_path__ + "static/media/serviceType.322a5949d3437bd5857b75572e6ab1f5.svg";
export { ForwardRef as ReactComponent };